import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBuildingBlock32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconBuildingBlock32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 7h-2a1 1 0 0 0-1 1v1h4V8a1 1 0 0 0-1-1M7 8v1a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4V8a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1h-2V8a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3m12 1h4V8a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1zm-2 2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBuildingBlock32);
